import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import { File, Product } from 'depoto-core/src/entities'
import { ModalContainerComponent } from '../../_common/modal-container/modal-container.component'
import { CoreService, HsApiService, NotificationService } from '../../../services'
import { TranslateService } from '@ngx-translate/core'
import { getThumbUrl as imageGetThumbUrl } from '../../../utils'

@Component({
  selector: 'app-modal-product-hs-sync',
  templateUrl: './modal-product-hs-sync.component.html',
  styleUrls: ['./modal-product-hs-sync.component.scss'],
})
export class ModalProductHsSyncComponent implements OnInit {
  @ViewChild('modalHsSync') public childModal: ModalContainerComponent
  @Input() product: Product
  @Input() hsProductRef: string
  @Output() onInitialFetching: EventEmitter<boolean> = new EventEmitter<boolean>()
  @Output() onSelected: EventEmitter<any> = new EventEmitter<any>()
  isLoading = false
  isNotFound = false
  timer = null
  searchPhrase: string
  server: string
  templates = []
  paginationDetail = ''

  constructor(
    private core: CoreService,
    private hsApi: HsApiService,
    private notificationService: NotificationService,
    private translateService: TranslateService,
  ) {}

  async ngOnInit() {
    this.isLoading = false
    if (this.product?.externalId?.length > 0) {
      await this.getConnectedTemplate()
    }
  }

  async fetchTemplates() {
    try {
      const response = await this.hsApi.searchForHsTemplate(this.searchPhrase, [], true)
      this.paginationDetail = this.translateService.instant('product.template.paginationDetail', {
        numberShown: `${response?.items?.length || 0}`,
        numberAll: `${response?.paginator?.totalCount || 0}`,
      })
      this.templates = response?.items || []
      if (!this.templates.length) {
        this.isNotFound = true
      }
    } catch (err) {
      console.log(err)
    } finally {
      this.isLoading = false
    }
  }

  debounce(func, timeout = 300) {
    return (...args) => {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        func.apply(this, args)
      }, timeout)
    }
  }
  public async templateSearchChange() {
    this.debounce(() => this.searchForTemplate(), 500)()
  }

  public async getConnectedTemplate() {
    this.isLoading = true
    this.isNotFound = false
    this.onInitialFetching.emit(true)
    const template = await this.hsApi.getHsTemplate(this.product.externalId)
    if (template) {
      this.templates = [template]
      this.selectTemplate(this.templates[0], true)
      this.templates = []
    } else {
      this.notificationService.error(this.translateService.instant('alert.product.hs-sync.404'))
    }
    this.onInitialFetching.emit(false)
    this.isLoading = false
  }

  public async searchForTemplate() {
    this.isLoading = true
    this.isNotFound = false
    await this.fetchTemplates()
    this.isLoading = false
  }

  async selectTemplate(template, isOnInit?: boolean) {
    this.onSelected.emit({ template, isOnInit })
    this.hideChildModal()
  }

  public async showChildModal() {
    this.childModal.showChildModal()
  }

  public hideChildModal(): void {
    this.childModal.hideChildModal()
  }

  getThumbUrl(image: File, format: 'w135wp' | 'w2048wp' = 'w135wp'): string {
    return imageGetThumbUrl(image, format)
  }
}
